import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import RequireAuth from '../auth/RequireAuth';
import CollapsibleSidebarLayout from '../dashboard/CollapsibleSidebarLayout';
import DashboardHeader from '../dashboard/DashboardHeader';
import ConsumerGuard from './ConsumerGuard';
import ConsumerSidebar from './ConsumerSidebar';

import { AuthProvider } from '@/context/AuthContext';

const ConsumerDashboardLayout = () => {
	const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(true);

	const toggleSidebar = () => {
		setIsSidebarOpen((prev) => !prev);
	};
	return (
		<>
			<AuthProvider>
				<RequireAuth>
					<ConsumerGuard>
						<CollapsibleSidebarLayout
							sidebar={<ConsumerSidebar />}
							header={<DashboardHeader onMenuClick={toggleSidebar} />}
							isSidebarOpen={isSidebarOpen}
							toggleSidebar={toggleSidebar}
							contentBg="bg-grey-10"
						>
							<Outlet />
						</CollapsibleSidebarLayout>
					</ConsumerGuard>
				</RequireAuth>
			</AuthProvider>
		</>
	);
};

export default ConsumerDashboardLayout;
